import { useState, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import useSettingApi from '../api/useSettingApi';

const useSettingData = () => {
    const [systemData, setSettingData] = useState([]);
    const { getSettings } = useSettingApi();

    const getSystemSettingQuery = useQuery({
        queryKey: ['systemData'],
        queryFn: getSettings,
        staleTime: 1000 * 30,
        retry: 1,
    });

    useMemo(() => {
        if (getSystemSettingQuery.status === 'error') {
            toast.error(getSystemSettingQuery.error?.response?.data?.message || getSystemSettingQuery.error.message);
        }
    }, [getSystemSettingQuery.status, getSystemSettingQuery.error]);

    useMemo(() => {
        if (getSystemSettingQuery.status === 'success') {
            const systemData = getSystemSettingQuery?.data;
            // console.log('🚀 ~ useMemo ~ medicineOrdersData:', medicineOrdersData);
            setSettingData(systemData); // no spread
        }
    }, [getSystemSettingQuery.status, getSystemSettingQuery.data]);

    return {
        systemData,
        isLoading: getSystemSettingQuery.isLoading,
        isError: getSystemSettingQuery.isError,
        error: getSystemSettingQuery.error,
        refetch: getSystemSettingQuery.refetch,
    };
};

export default useSettingData;